module.exports = __webpack_public_path__ + "static/media/myriad-pro-black.47b279ee.otf";